import React, { useState, useEffect } from 'react';
import './cart.css';
import { Divider } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { useCart, useDispatchCart } from '../contextreducer/ContextReducer'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL } from '../helper';



export default function Cart() {
    const { postId } = useParams();
    const navigate = useNavigate();
    const [getdatabyID, setgetdatabyID] = useState({});

    const data = Array.from(useCart());
    const dispatch = useDispatchCart()
    

    const handleAddCart = async () => {
        const existingItem = data.find(item => item.shortTitle === getdatabyID.title.shortTitle);
        if (existingItem) {
            const updatedItem = {
                ...existingItem,
                quantity: existingItem.quantity + 1
            };
            await dispatch({
                type: "UPDATE",
                item: updatedItem
            });
            toast.success("This item updated in Cart ✅!", {
                position: "top-center",
                autoClose: 2000,
            });
            setTimeout(() => {
                navigate('/buynow');
            }, 2000);
                    
        } else {
            await dispatch({
                type: "ADD",
                shortTitle: getdatabyID.title.shortTitle,
                longTitle: getdatabyID.title.longTitle,
                img: getdatabyID.url,
                price: getdatabyID.price.cost,
                quantity: 1
            });
            toast.success("This item Added in your Cart ✅!", {
                position: "top-center",
                autoClose: 2000,
            });
            setTimeout(() => {
                navigate('/buynow');
            }, 2000);
        }
        // setTimeout(window, 2000)
        console.log(data);
    };

    // const removestate =() => {
    //     dispatch({ type: "DROP" })
    // }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${BASE_URL}/api/get/${postId}`);
                const jsonData = await response.json();
                setgetdatabyID(jsonData);
            } catch (error) {
                console.log(error);
            }
        };
        setTimeout(fetchData, 2000);
    }, [postId]);

    // Check if getdatabyID is empty or if title is undefined
    if (Object.keys(getdatabyID).length === 0) {
        return (
            <div className="cart_section">
                <div className="circle">
                    <CircularProgress />
                    <h2> Loading....</h2>
                </div>
            </div>
        );
    }


    return (
        <div className="cart_section">
            <div className="cart_container">
                <div className="left_cart">
                    <img src={getdatabyID.detailUrl} alt="cart" />
                    <div className="cart_btn">
                        <button className="cart_btn1" onClick={handleAddCart}>Add to Cart</button>
                        <button className="cart_btn2">Buy Now</button>
                        {/* <button className="cart_btn1" onClick={removestate}>cler state</button> */}
                    </div>
                </div>
                <div className="right_cart">
                    <h3>{getdatabyID.title.shortTitle}</h3>
                    <h4>{getdatabyID.title.longTitle}</h4>
                    <Divider />
                    <p className="mrp">
                        M.R.P. : <del>{getdatabyID.price.mrp}₹/-</del>
                    </p>
                    <p>
                        Deal of the Day : <span style={{ color: "#B12704" }}>{getdatabyID.price.cost}₹/-</span>
                    </p>
                    <p>
                        You save : <span style={{ color: "#B12704" }}> {getdatabyID.price.discount}</span>
                    </p>
                    <div className="discount_box">
                        <h5>
                            Discount : <span style={{ color: "#111" }}>{getdatabyID.discount}</span>{" "}
                        </h5>
                        <h4>
                            FREE Delivery : <span style={{ color: "#111", fontWeight: "600" }}>Oct 8 - 21</span> Details
                        </h4>
                        <p style={{ color: "#111" }}>
                            Fastest delivery: <span style={{ color: "#111", fontWeight: "600" }}> Tomorrow 11AM</span>
                        </p>
                    </div>
                    <p className="description">
                        About the Item:{" "}
                        <span style={{ color: "#565959", fontSize: "14px", fontWeight: "500", letterSpacing: "0.4px" }}>
                            {getdatabyID.description}
                        </span>
                    </p>
                </div>
            </div>
            {/* <div className='product_slide'>
                <Slide title="More items to explore"/>
            </div> */}
            <ToastContainer />
        </div>
    );
}
